export const Dashicon4 = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.07161 9C7.3452 5.06204 8.48199 3.09306 9.96613 2.43227C11.2607 1.85591 12.739 1.85591 14.0335 2.43227C15.5176 3.09306 16.6544 5.06204 18.928 9C21.2016 12.938 22.3384 14.9069 22.1686 16.5226C22.0205 17.9319 21.2813 19.2122 20.1349 20.0451C18.8206 21 16.547 21 11.9998 21C7.45265 21 5.17906 21 3.86474 20.0451C2.71832 19.2122 1.97917 17.9319 1.83105 16.5226C1.66124 14.9069 2.79803 12.938 5.07161 9ZM11.9998 6.25C12.414 6.25 12.7498 6.58579 12.7498 7V13C12.7498 13.4142 12.414 13.75 11.9998 13.75C11.5855 13.75 11.2498 13.4142 11.2498 13V7C11.2498 6.58579 11.5855 6.25 11.9998 6.25ZM11.9998 17C12.552 17 12.9998 16.5523 12.9998 16C12.9998 15.4477 12.552 15 11.9998 15C11.4475 15 10.9998 15.4477 10.9998 16C10.9998 16.5523 11.4475 17 11.9998 17Z"
          fill="#FFA820"
        />
      </svg>
    </>
  );
};
